import { __SelectNetworkModalProps } from './selectNetworksModal.interface';
import { FC } from 'react';
import { SiPayModal } from 'utilities/components';

export const SelectNetworkModal: FC<__SelectNetworkModalProps> = (props: __SelectNetworkModalProps) => {
    return (
        <SiPayModal isOpen={props.isOpen} onClose={props.onClose} title='انتخاب شبکه'>
            <div dir='ltr' className='max-h-[352px] flex flex-col overflow-auto gap-1 -mr-3 pr-3'>
                {props.networks.length !== 0 ? props.networks.map((item, index) => (
                    <div onClick={() => props.onSelect(item)} dir='rtl' className='w-full min-h-12 rounded-lg flex items-center px-3 text-darkPurple-100 hover:text-primary-100 hover:bg-[#F1F8FF80] cursor-pointer' key={index} >
                        <h4 className='text-base font-bold en'>{item.name}</h4>
                    </div>
                )) : <div className='flex flex-col gap-6 items-center justify-center pt-2'>
                    <h6 className='text-base font-medium text-darkPurple-80'>داده‌ای موجود نیست</h6>
                </div>
                }
            </div>
        </SiPayModal>
    );
};